export function cssBaseline() {
  // NOTE: the Inter @font-face lives in index.html — MUI v6 + Emotion ignores the legacy
  // JSS `@global` styleOverrides key, so declaring the web font here did not register it.
  return {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          boxSizing: 'border-box'
        },
        html: {
          backgroundColor: '#fafafa',
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch'
        },
        body: {
          backgroundColor: '#fafafa',
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          // Inter variable font ships an optical-size axis — let the browser apply it.
          fontOpticalSizing: 'auto'
        },
        '#root, #__next': {
          width: '100%',
          height: '100%'
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none'
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none'
            }
          }
        },
        img: {
          maxWidth: '100%',
          display: 'inline-block',
          verticalAlign: 'bottom'
        }
      }
    }
  };
}
